import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Close(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M14.121 12l7.44-7.44a1.5 1.5 0 00-2.121-2.12L12 9.879l-7.44-7.44A1.501 1.501 0 002.44 4.56L9.88 12l-7.44 7.439a1.5 1.5 0 002.12 2.122L12 14.12l7.44 7.44c.293.293.677.439 1.06.439a1.5 1.5 0 001.06-2.561l-7.439-7.44z"
  }));
}

export { Close };
//# sourceMappingURL=Close.js.map